/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

import {Component, inject, Input} from '@angular/core';
import {IxModule} from '@siemens/ix-angular';
import {KeyValueComponent} from '../../../shared/pass-viewer/components/key-value/key-value.component';
import {LocalizationHelper} from '../../../shared/utils/localization-helper';
import {
  MultiLanguageProperty,
  SubmodelElement,
  SubmodelElementCollection,
  SubmodelElementList,
  SubmodelElementTypes,
} from '@product-passport/dpp/model';
import {TranslateOrFallbackPipe} from './utils/translate-or-fallback.pipe';

@Component({
  selector: 'app-dpp-submodel-field',
  templateUrl: './dpp-submodel-field.component.html',
  styleUrl: './dpp-submodel-field.component.scss',
  imports: [
    IxModule,
    KeyValueComponent,
    TranslateOrFallbackPipe,
    DppSubmodelFieldComponent,
  ],
})
export class DppSubmodelFieldComponent {
  private readonly localizationHelper = inject(LocalizationHelper);

  protected readonly SubmodelElementTypes = SubmodelElementTypes;

  @Input({required: true}) element!: SubmodelElement;

  get icon(): string {
    switch (this.element.modelType) {
      case SubmodelElementTypes.MultiLanguageProperty:
        return 'language';
      case SubmodelElementTypes.File:
        return 'document';
      default:
        return 'data-type-string';
    }
  }

  get children(): SubmodelElement[] {
    return (this.element as SubmodelElementCollection).value ?? [];
  }

  get listItems(): SubmodelElement[] {
    return (this.element as SubmodelElementList).value ?? [];
  }

  listItemChildren(item: SubmodelElement): SubmodelElement[] {
    if (item.modelType !== SubmodelElementTypes.SubmodelElementCollection) {
      return [];
    }
    return (item as SubmodelElementCollection).value ?? [];
  }

  get leafValue(): string {
    const el = this.element as unknown as Record<string, unknown>;
    if (this.element.modelType === SubmodelElementTypes.MultiLanguageProperty) {
      const mlp = this.element as MultiLanguageProperty;
      return this.localizationHelper.getLocalizedText(mlp.value);
    }
    const value = el['value'];
    if (typeof value === 'string') {
      return value;
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
      return String(value);
    }
    return '—';
  }
}
